export const heapTrack = (eventName: string, data = {}) => {
  if (window && (window as any).heap) {
    console.log("HEAP WORKS", eventName, data);
    (window as any).heap.track(eventName, data);
  }
};
